"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApplicationFeeCap = void 0;
const constants_1 = require("../constants");
const convertToLocalCurrency = ({ amountUsd, rates, currency, }) => {
    const currencyRate = rates[currency];
    if (!currencyRate) {
        throw new Error(`Could not find rate for currency: ${currency}`);
    }
    return amountUsd * currencyRate;
};
// @NOTE-CH: Copied from https://github.com/joindeed/api/blob/main/server/api/donation/calculateFeesWithHistory.ts#L14-L43
const getApplicationFeeCap = ({ amountUsd, rates, currency, }) => convertToLocalCurrency({
    amountUsd: amountUsd || constants_1.DEFAULT_DEED_FEE_CAP_USD,
    rates,
    currency,
});
exports.getApplicationFeeCap = getApplicationFeeCap;
//# sourceMappingURL=getApplicationFeeCap.js.map